import { useMutation } from 'react-query';

import { deleteComment } from '@utils/backend-api/comments';

export default function useCommentDelete() {
  const { mutate, mutateAsync, isLoading, isError } = useMutation((id: number) =>
    deleteComment(id)
  );
  return { mutate, mutateAsync, isLoading, isError };
}
